import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { tualatinConfig } from "./data";

export default function TualatinPage() {
  return <OregonCityPageTemplate config={tualatinConfig} />;
}